import { gql } from 'urql'

export const FORM_SIDES = [
  { value: 'LEFT', label: 'Formulario a la izquierda', shortLabel: 'Izquierda' },
  { value: 'RIGHT', label: 'Formulario a la derecha', shortLabel: 'Derecha' },
]

export const formatFormSide = (value) =>
  FORM_SIDES.find((item) => item.value === value)?.label || 'Formulario a la izquierda'

export const GET_SIGNIN_TEMPLATES = gql`
  query SigninTemplates {
    signinTemplates {
      id
      name
      html
      formSide
      formWidth
      formBgColor
      isActive
      createdBy
      updatedBy
      createdAt
      updatedAt
    }
  }
`

export const CREATE_SIGNIN_TEMPLATE = gql`
  mutation CreateSigninTemplate($input: CreateSigninTemplateInput!) {
    createSigninTemplate(input: $input) {
      id
      name
      formSide
      formWidth
      formBgColor
      isActive
    }
  }
`

export const UPDATE_SIGNIN_TEMPLATE = gql`
  mutation UpdateSigninTemplate($input: UpdateSigninTemplateInput!) {
    updateSigninTemplate(input: $input) {
      id
      name
      formSide
      formWidth
      formBgColor
      isActive
    }
  }
`

export const DELETE_SIGNIN_TEMPLATE = gql`
  mutation DeleteSigninTemplate($id: ID!) {
    deleteSigninTemplate(id: $id)
  }
`

export const SET_SIGNIN_TEMPLATE_ACTIVE = gql`
  mutation SetSigninTemplateActive($id: ID!, $isActive: Boolean!) {
    setSigninTemplateActive(id: $id, isActive: $isActive) {
      id
      isActive
    }
  }
`

export const SET_DEFAULT_LOGIN = gql`
  mutation SetDefaultLogin {
    setDefaultLogin
  }
`

export const GET_SIGNIN_ASSET_UPLOAD_URL = gql`
  mutation GetSigninAssetUploadUrl($fileName: String!, $fileType: String!) {
    getSigninAssetUploadUrl(fileName: $fileName, fileType: $fileType) {
      uploadUrl
      fileUrl
      key
    }
  }
`

/**
 * Sube una imagen a S3 vía presigned PUT y devuelve su URL pública permanente.
 * @param file - File del input
 * @param getUploadUrl - función de la mutación urql GET_SIGNIN_ASSET_UPLOAD_URL
 */
export async function uploadSigninImage(file, getUploadUrl) {
  const result = await getUploadUrl({ fileName: file.name, fileType: file.type })
  if (result.error) throw result.error
  const upload = result.data?.getSigninAssetUploadUrl
  if (!upload?.uploadUrl) throw new Error('No se pudo generar la URL de subida.')

  const putResponse = await fetch(upload.uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': file.type },
    body: file,
  })
  if (!putResponse.ok) {
    throw new Error(`Falló la subida a S3 (${putResponse.status}).`)
  }
  return upload.fileUrl
}
